import React from "react";
import { useDrop } from "react-dnd";
import styled from "styled-components";

const SlotContainer = styled.div`
  position: relative;   /* needed for absolute button */
  width: 100px;
  height: 100px;
  background: ${({ hasPiece, isOver }) =>
    hasPiece
      ? "transparent"
      : isOver
      ? "rgba(255, 255, 255, 0.2)"
      : "rgba(0, 0, 0, 0.2)"};
  border: ${({ isOver }) =>
    isOver ? "3px dashed #fff" : "2px dashed rgba(255, 255, 255, 0.3)"};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.2s, border 0.2s, box-shadow 0.2s;
  box-shadow: ${({ isOver }) =>
    isOver ? "0 0 20px rgba(255, 255, 255, 0.3)" : "none"};
  backdrop-filter: blur(2px);

  @media (max-width: 600px) {
    width: 80px;
    height: 80px;
  }
  @media (max-width: 400px) {
    width: 62px;
    height: 62px;
  }
`;

const PieceImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  border: 2px solid #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  cursor: pointer;    /* indicate clickable */
`;

const RemoveButton = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 24px;
  height: 24px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background: rgba(255, 0, 0, 0.8);
  color: white;
  border: 2px solid white;

  font-size: 14px;
  font-weight: bold;
  line-height: 1;

  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.15);
  }
`;

const Placeholder = styled.span`
  color: rgba(255, 255, 255, 0.5);
  font-size: 2rem;
  line-height: 1;
`;

const PuzzleTarget = ({ id, placedPiece, onDrop, onRemovePiece }) => {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: "PIECE",
      drop: (item) => onDrop(item.piece, id),
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [id, onDrop]
  );

  // Click handler for removal
  const handleRemove = (e) => {
    e.stopPropagation();  // prevent accidental drop triggers
    if (placedPiece && onRemovePiece) {
      onRemovePiece(id, placedPiece);
    }
  };

  return (
    <SlotContainer ref={drop} isOver={isOver} hasPiece={!!placedPiece}>
      {placedPiece ? (
        <>
          <PieceImage
            src={placedPiece.src}
            alt="placed piece"
            onClick={handleRemove}
          />
          <RemoveButton onClick={handleRemove}>✕</RemoveButton>
        </>
      ) : (
        <Placeholder>✨</Placeholder>
      )}
    </SlotContainer>
  );
};

export default PuzzleTarget;